// extracted by mini-css-extract-plugin
export default {"scrollable":"MusicList_scrollable__Sj1R2","scrollableH3":"MusicList_scrollableH3__+xtm3"};